export const PageDataState = {
    Searchs: {
        external_user_id: {
            type: 'text',
            id: 'external_user_id',
            label: '',
            value: '',
        },
        enterprise: {
            type: 'text',
            id: 'enterprise',
            label: 'สถานประกอบการ',
            value: '',
            placeholder: 'สถานประกอบการ',
        },
        course: {
            type: 'text',
            id: 'course',
            label: 'หลักสูตร',
            value: '',
            placeholder: 'หลักสูตร',
        },
    },
    Inputs: {
        id: {
            type: 'text',
            id: 'id',
            label: 'รหัส',
            value: '',
            validator: {
                type: 'primaryKey',
                required: false,
            },
            error: { status: null, msg: '' }
        },
        external_user_id: {
            type: 'select',
            id: 'external_user_id',
            label: 'ผู้ใช้งานภายนอก',
            value: '',
            validator: {
                type: 'text',
                required: true,
            },
            error: { status: null, msg: '' }
        },
        enroll_key: {
            type: 'text',
            id: 'enroll_key',
            label: 'ENROLL KEY',
            value: '',
            validator: {
                type: 'text',
                required: false,
                minLength: 5,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        },        
        enterprise: {
            type: 'text',
            id: 'enterprise',
            label: 'สถานประกอบการ',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 5,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        },
        position: {
            type: 'text',
            id: 'position',
            label: 'ตำแหน่ง',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 5,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        },
        course: {
            type: 'text',
            id: 'course',
            label: 'หลักสูตร',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 5,
                maxLength: 4096
            },
            error: { status: null, msg: '' }
        },        
        description: {
            type: 'textarea',
            rows: 3,
            id: 'description',
            label: 'เนื้อหาหลักสูตรโดยสรุป',
            value: '',
            validator: {
                type: 'text',
                required: false,
                minLength: 5,
                maxLength: 4096
            },
            error: { status: null, msg: '' }
        },
        cost: {
            type: 'text',
            id: 'cost',
            label: 'ค่าใช้จ่าย',
            value: '',
            validator: {
                type: 'number',
                required: true,
                min: 100,
                max: 200000
            },
            error: { status: null, msg: '' }
        },
        training_start_date: {
            type: 'text',
            id: 'training_start_date',
            label: 'วันที่เริ่มต้น',
            value: '',
            validator: {
                type: 'date',
                required: true,
            },
            error: { status: null, msg: '' }
        },
        training_end_date: {
            type: 'text',
            id: 'training_end_date',
            label: 'วันที่สิ้นสุด',
            value: '',
            validator: {
                type: 'date',
                required: true,
            },
            error: { status: null, msg: '' }
        },
        training_days: {
            type: 'text',
            id: 'training_days',
            label: 'จำนวนวันที่อบรม',
            value: '',
            validator: {
                type: 'number',
                required: true,
                min: 1,
                max: 31
            },
            error: { status: null, msg: '' }
        },
        training_hours: {
            type: 'text',
            id: 'training_hours',
            label: 'จำนวนชั่วโมงที่ฝึกอบรม',
            value: '',
            validator: {
                type: 'number',
                required: true,
                min: 1,
                max: 360
            },
            error: { status: null, msg: '' }
        },                
        location: {
            type: 'textarea',
            rows: 3,
            id: 'location',
            label: 'สถานที่จัดอบรม',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 5,
                maxLength: 4096
            },
            error: { status: null, msg: '' }
        },
        organize: {
            type: 'text',
            id: 'organize',
            label: 'ผู้จัดอบรม',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 5,
                maxLength: 4096
            },
            error: { status: null, msg: '' }
        },        
        training_evidence: {
            type: 'file',
            id: 'training_evidence',
            label: 'เอกสารหลักฐานประกอบ',
            fileId: '',  
            fileName: '', 
            fileInfo: {},
            value: '',
            validator: {
                type: 'file',
                required: false,
                accept: "application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            },            
            error: { status: null, msg: '' }
        },
        status: {
            type: 'select',
            id: 'status',
            label: 'สถานะ',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 1,
                maxLength: 1
            },
            error: { status: null, msg: '' }
        },        
    },
    InputGroup: {}
}